import dayjs from "../dayjs-config";
import getTimeDecodingFormat from "../FormattedTime/getTimeFormat";
var localizedFormats = ['LT', 'LTS', 'L', 'LL', 'LLL', 'LLLL', 'l', 'll', 'lll', 'llll'];
export function getDayjsDate(date, desiredFormat) {
  if (desiredFormat === 'time') {
    var decodingFormat = getTimeDecodingFormat(date);
    return dayjs(date, decodingFormat);
  }

  return dayjs(date);
}
export function formatDateByPreferences(dayjsDate, dateFormat, preferences) {
  function applyPreferencesOnFormats(formats) {
    return formats.map(function (format) {
      if (localizedFormats.includes(format)) {
        var _preferences$dateTime, _preferences$dateTime2;

        return (_preferences$dateTime = preferences === null || preferences === void 0 ? void 0 : (_preferences$dateTime2 = preferences.dateTimeFormat) === null || _preferences$dateTime2 === void 0 ? void 0 : _preferences$dateTime2[format]) !== null && _preferences$dateTime !== void 0 ? _preferences$dateTime : format;
      }

      return format;
    });
  }

  var receivedDateFormats = dateFormat.split(' '); // if any of the passed formats is not localized we will just use them as is.

  if (receivedDateFormats.every(function (format) {
    return localizedFormats.includes(format);
  })) {
    var finalDateFormats = [];
    receivedDateFormats.forEach(function (format) {
      switch (format) {
        case 'LLL':
          finalDateFormats.push('LL', 'LT');
          break;

        case 'LLLL':
          finalDateFormats.push('dddd', 'LL', 'LT');
          break;

        case 'lll':
          finalDateFormats.push('ll', 'LT');
          break;

        case 'llll':
          finalDateFormats.push('ddd', 'll', 'LT');
          break;

        default:
          finalDateFormats.push(format);
      }
    });
    var dayjsFormat = applyPreferencesOnFormats(finalDateFormats).join(' ');
    return dayjsDate.format(dayjsFormat);
  }

  return dayjsDate.format(dateFormat);
}